export const SEGMENT_NAME_MIN_LENGTH = 2;

export const SEGMENT_NAME_MAX_LENGTH = 60;

export const SEGMENT_NAME_ERROR = `Entre ${SEGMENT_NAME_MIN_LENGTH} et ${SEGMENT_NAME_MAX_LENGTH} caractères`;

export const isSegmentNameValid = (name: string): boolean => {
  const trimmedLength = name.trim().length;
  return trimmedLength >= SEGMENT_NAME_MIN_LENGTH && trimmedLength <= SEGMENT_NAME_MAX_LENGTH;
};
